import { render, staticRenderFns } from "./CriteriaGroupsPage.vue?vue&type=template&id=3ede2c1c&scoped=true"
import script from "./CriteriaGroupsPage.vue?vue&type=script&lang=js"
export * from "./CriteriaGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./CriteriaGroupsPage.vue?vue&type=style&index=0&id=3ede2c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede2c1c",
  null
  
)

export default component.exports